module.exports = __webpack_public_path__ + "img/OKKI.8ec139cf.svg";